<div class="flex flex-1 flex-col overflow-visible pb-2">
  <form novalidate [formGroup]="updatePasswordForm">
    <div class="row">
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6">
        <label class="block text-sm mb-2" for="password">{{ 'CHANGE_PASSWORD_FORM.NEW_PASSWORD' | translate }} <i
        class="icon-required-field"></i></label>
        <p-password id="password" formControlName="password" class="w-100">
          <ng-template pTemplate="content">
            <h3 class="text-sm font-medium">{{ 'CHANGE_PASSWORD_FORM.PASS_POLICY' | translate }}</h3>
            <hr role="presentation" class="w-full mb-3 mt-2 border-t">
          </ng-template>
          <ng-template pTemplate="footer">
            <ul class="text-sm mb-0">
              <li>{{ 'CHANGE_PASSWORD_FORM.PASS_POLICY_MIN_8_CHARACTERS' | translate }}</li>
              <li>{{ 'CHANGE_PASSWORD_FORM.PASS_POLICY_AT_LEAST_ONE_LOWERCASE' | translate }}</li>
              <li>{{ 'CHANGE_PASSWORD_FORM.PASS_POLICY_AT_LEAST_ONE_UPPERCASE' | translate }}</li>
              <li>{{ 'CHANGE_PASSWORD_FORM.PASS_POLICY_AT_LEAST_ONE_NUMBER' | translate }}</li>
              <li>{{ 'CHANGE_PASSWORD_FORM.PASS_POLICY_AT_LEAST_ONE_SPECIAL_CHAR' | translate }}</li>
            </ul>
          </ng-template>
        </p-password>
        @if (updatePasswordForm.get('password')?.invalid && (updatePasswordForm.get('password')?.dirty || updatePasswordForm.get('password')?.touched)) {
          @if (updatePasswordForm.get('password')?.hasError('required')) {
            <small class="p-error">
              {{ 'YOUR_ACCOUNT.VALIDATE_PASSWORD' | translate }}
            </small>
          }
          @if (updatePasswordForm.get('password')?.errors?.['invalidPassword']) {
            <small class="p-error">
              {{ 'YOUR_ACCOUNT.FORMAT_PASSWORD' | translate }}
            </small>
          }
        }
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6">
        <label class="block text-sm" for="confirmPassword">{{ 'CHANGE_PASSWORD_FORM.CONFIRM_PASSWORD' | translate }}</label>
        <input id="confirmPassword" type="password" formControlName="confirmPassword">
        @if (updatePasswordForm.get('confirmPassword')?.touched && (updatePasswordForm.get('confirmPassword')?.invalid || updatePasswordForm.get('confirmPassword')?.dirty)) {
          @if (updatePasswordForm.get('confirmPassword')?.errors?.['passwordMismatch']) {
            <small class="p-error">{{
              'YOUR_ACCOUNT.VALIDATE_PASSWORD_MATCH' | translate }}
            </small>
          }
          @if (!updatePasswordForm.get('confirmPassword')?.errors?.['passwordMismatch'] && updatePasswordForm.get('confirmPassword')?.hasError('required')) {
            <small class="p-error"
              >
              {{ 'YOUR_ACCOUNT.VALIDATE_CONFIRM_PASSWORD' | translate }}
            </small>
          }
        }
      </div>
    </div>

    <div class="row">
      <div class="col-12 pt-2">
        <div class="flex items-center justify-end gap-3">
          <button class="btn primary-btn w-full" (click)="onSaveClick($event)" [disabled]="!updatePasswordForm.valid">{{
          'CHANGE_PASSWORD_FORM.SAVE_BUTTON' | translate }}</button>
        </div>
      </div>
    </div>
  </form>
</div>
